import styled from '@emotion/styled';
import moment from 'moment';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {mixinFlexboxRow} from 'webapp-lib/styling';
import {useMountEffect} from 'webapp-lib/utils';

import {TimeEntryResponse} from '@lexian/api/timetracker-api';

function formatDuration(totalSeconds: number) {
  const milliseconds = moment
    .duration(totalSeconds, 'seconds')
    .asMilliseconds();
  return moment.utc(milliseconds).format('HH:mm:ss');
}

export function ElapsedTime({
  ongoingEntry,
}: {
  ongoingEntry: TimeEntryResponse;
}): React.ReactElement {
  const {t} = useTranslation('timetracker');

  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const startTime = moment(ongoingEntry.startTime);

  const updateElapsedTime = () => {
    setElapsedSeconds(moment().diff(startTime, 'seconds'));
  };

  useMountEffect(() => {
    updateElapsedTime();
    const interval = setInterval(updateElapsedTime, 1_000);

    return () => clearInterval(interval);
  });

  return (
    <StyledElapsedTime>
      <div>
        {t('components.timer.startTime', {
          time: moment(ongoingEntry.startTime).format('HH:mm'),
        })}
      </div>
      <div>{formatDuration(elapsedSeconds)}</div>
    </StyledElapsedTime>
  );
}

const StyledElapsedTime = styled.div`
  ${mixinFlexboxRow};
  align-items: center;
  gap: var(--gutter-large);
`;
